.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
}

/* The wrapped icon is an <svg>. Setting width/height to 1em lets it pick
 * up our per-size font-size from the wrapper span. `color: inherit` lets
 * the svg's own `stroke="currentColor"` (set by @untitledui/icons by
 * default) pick up the tone color applied to the wrapper span.
 *
 * Do NOT set `fill: currentColor` here — @untitledui/icons are stroke-only
 * line art with `fill="none"` on the svg. Forcing fill via CSS overrides
 * the presentation attribute and turns closed shapes (InfoCircle, Bell01,
 * Settings01, AlertTriangle, etc.) into filled blobs instead of outlines.
 * If a filled-style icon library is ever mixed in, the icon components
 * themselves can set their own fill via the `color` attribute or inline
 * style on the svg. */
.icon > svg {
  width: 1em;
  height: 1em;
  color: inherit;
}

/* size */
.size-xs { font-size: 14px; }
.size-sm { font-size: 16px; }
.size-md { font-size: 20px; }
.size-lg { font-size: 24px; }

/* tone — maps to Figma --icon-* alias tokens */
.tone-default  { color: var(--icon-default); }
.tone-muted    { color: var(--icon-muted); }
.tone-negative { color: var(--icon-negative); }
.tone-on-dark  { color: var(--icon-on-dark); }
.tone-outline  { color: var(--icon-outline); }
.tone-inherit  { color: inherit; }
